"use client";

import React, { useEffect, useState, Suspense, lazy } from "react";
import { Card, Box, Typography } from "@mui/material";

const Chart = lazy(() => import("react-apexcharts"));

const PeakChatTimes = ({ data = [] }) => {
  const [isChartLoaded, setChartLoaded] = useState(false);

  useEffect(() => {
    setChartLoaded(true);
  }, []);

  // Extract time ranges and message counts from data
  const categories = data.map(item => item.time_range || 'Unknown');
  const messageData = data.map(item => item.message_count || 0);

  // Generate colors based on data length
  const colors = messageData.map((_, idx) =>
    idx % 2 === 0 ? '#605DFF' : '#FF6B6B'
  );

  const options = {
    chart: { type: 'bar', toolbar: { show: false } },
    plotOptions: {
      bar: {
        borderRadius: 4,
        distributed: true,
      }
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: categories.length > 0 ? categories : ['No Data'],
      labels: { style: { colors: '#64748B' } }
    },
    yaxis: {
      labels: { style: { colors: '#64748B' } }
    },
    colors: colors,
    grid: { borderColor: '#ECEEF2' }
  };

  const series = [{
    name: 'Interactions',
    data: messageData.length > 0 ? messageData : [0]
  }];

  return (
    <Card sx={{ boxShadow: "none", borderRadius: "7px", p: 3, height: "100%" }}>
      <Typography variant="h6" fontWeight={700} mb={2} className="text-black">
        Peak Chat Times
      </Typography>
      <Box sx={{ height: 300 }}>
        {isChartLoaded && (
          <Suspense fallback={<div>Loading...</div>}>
            <Chart options={options} series={series} type="bar" height={300} />
          </Suspense>
        )}
      </Box>
    </Card>
  );
};

export default PeakChatTimes;